import actionTypes from 'redux/actionTypes';

const initialState = {
	status: undefined,
	isFirstTimeUser: false,
	tourLoading: true,
	tourErr: false,
	/**
	 * This flag is changed from Preview page Help -> Start Tour,
	 * used to handle Cancel btn in Tour starter page
	 */
	isTourFromHelp: false,
	/**
	 * To show the Starter page & tour guide steps
	 */
	showTourStarter: false,
	showPreviewElementsTour: false,
	/**
	 * Custom data set Tour
	 */
	CDTourRun: false,
	CDTourStepIndex: 0
};

const tourReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case actionTypes.GET_FIRSTTIME_USR_STATUS:
			return {
				...state
			};
		case actionTypes.SET_FIRSTTIME_USR_STATUS:
			return {
				...state,
				status: action.payload.statusCode,
				isFirstTimeUser: action.payload.json?.firstTimeUser,
				tourLoading: false
			};
		case actionTypes.ERR_FIRSTTIME_USR_STATUS:
			return {
				...state,
				tourLoading: false,
				tourErr: true,
				status: 505,
				isFirstTimeUser: true
			};
		case actionTypes.SET_PREVIEW_TOUR:
		case actionTypes.SET_CUSTOM_DATASET_TOUR:
			return {
				...state,
				...action.payload
			};
		case actionTypes.RESET_FIRSTTIME_USR_STATUS:
			return {
				...initialState
			};
		default:
			return state;
	}
};

export default tourReducer;
